const DOCX_MIME = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const DOC_MIME = "application/msword";
const PDF_MIME = "application/pdf";
const TXT_MIME = "text/plain";

const normalizeExtractedText = (text) =>
  (text || "")
    .replace(/\r\n/g, "\n")
    .replace(/\u00A0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim();

const getFileExtension = (fileName = "") => {
  const parts = fileName.toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
};

const extractDocTextViaBackend = async (file, backendBaseUrl) => {
  if (!backendBaseUrl) {
    throw new Error("Thiếu địa chỉ backend để đọc file .doc.");
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${backendBaseUrl}/api/file/extract-doc`, {
    method: "POST",
    body: formData,
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Không thể trích xuất nội dung từ file .doc.");
  }

  return normalizeExtractedText(payload.text);
};

const extractPdfText = async (file) => {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjs.getDocument({
    data: new Uint8Array(buffer),
    disableWorker: true,
  }).promise;

  const pages = [];

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
    const page = await pdf.getPage(pageNumber);
    const textContent = await page.getTextContent();
    const parts = [];

    textContent.items.forEach((item) => {
      const chunk = typeof item.str === "string" ? item.str.trim() : "";
      if (!chunk) {
        return;
      }

      parts.push(chunk);

      if (item.hasEOL) {
        parts.push("\n");
      }
    });

    pages.push(parts.join(" "));
  }

  return normalizeExtractedText(pages.join("\n\n"));
};

const extractDocxText = async (file) => {
  const mammoth = await import("mammoth/mammoth.browser");
  const buffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer: buffer });
  return normalizeExtractedText(result.value);
};

export const extractTextFromFile = async (file, options = {}) => {
  const { backendBaseUrl } = options;
  const extension = getFileExtension(file?.name);
  const fileType = file?.type || "";

  if (!file) {
    throw new Error("Không tìm thấy file để xử lý.");
  }

  if (fileType === TXT_MIME || extension === "txt") {
    return normalizeExtractedText(await file.text());
  }

  if (fileType === PDF_MIME || extension === "pdf") {
    return extractPdfText(file);
  }

  if (fileType === DOCX_MIME || extension === "docx") {
    return extractDocxText(file);
  }

  if (fileType === DOC_MIME || extension === "doc") {
    return extractDocTextViaBackend(file, backendBaseUrl);
  }

  throw new Error("Hiện tại chỉ hỗ trợ file TXT, PDF văn bản, DOCX và DOC.");
};
